// DMI's web search appends one citation to the end of some reasoning strings:
// ` ([colorado.gov](https://colorado.gov/...?utm_source=openai))`
const TRAILING_CITATION_REGEX = /\s*\(\[[^\]]*\]\(https:\/\/[^)]*\)\)\s*$/;

export function stripTrailingCitation(reasoning: string): string {
	return reasoning.replace(TRAILING_CITATION_REGEX, '');
}
